export const relativePath = (full, base)=>full.slice(base.length + 1);
export const withSplat = (url)=>url.endsWith('/*') ? url : "".concat(url.replace(/\/$/, ''), "/*");
